<template>
  <div class="container d-flex justify-content-center align-items-center flex-column">
    <h4 class="display-6 text-center mb-4 mt-4">
      Comparación de Totales por Año
    </h4>

    <!-- Filtros -->
    <div class="row g-2 mb-3 w-100">
      <!-- <div class="col-6 col-md-2">
        <label class="form-label">Año inicio</label>
        <input
          type="number"
          class="form-control"
          v-model.number="filtrosLocal.anioInicio"
        />
      </div>

      <div class="col-6 col-md-2">
        <label class="form-label">Año fin</label>
        <input
          type="number"
          class="form-control"
          v-model.number="filtrosLocal.anioFin"
        />
      </div> -->

      <div class="col-6 col-md-2">
        <label class="form-label">Tipo cartera</label>
        <select class="form-select" v-model="filtrosLocal.tipoCartera">
          <option value="">Todas</option>
          <option value="-1">Agricola</option>
          <option v-for="c in opcionesTipoCartera" :key="c.id" :value="c.id">
            {{ c.nombre }}
          </option>
        </select>
      </div>

      <div class="col-6 col-md-2">
        <label class="form-label">Estado</label>
        <select class="form-select" v-model="filtrosLocal.estado">
          <option value="">Todos</option>
          <option v-for="e in opcionesEstado" :key="e" :value="e">
            {{ e }}
          </option>
        </select>
      </div>
<!-- 
      <div class="col-6 col-md-2">
        <label class="form-label">Producto</label>
        <select class="form-select" v-model="filtrosLocal.producto">
          <option value="">Todos</option>
          <option v-for="p in opcionesProducto" :key="p" :value="p">
            {{ p }}
          </option>
        </select>
      </div>

      <div class="col-6 col-md-2">
        <label class="form-label">Asesor</label>
        <select class="form-select" v-model.number="filtrosLocal.userAdmin">
          <option :value="0">Todos</option>
          <option
            v-for="asesor in opcionesAsesores"
            :key="asesor.id"
            :value="asesor.id"
          >
            {{ asesor.nombre }}
          </option>
        </select>
      </div> -->
    </div>

    <!-- Botones -->
    <div class="mb-3 w-100">
      <button
        class="btn btn-sm btn-primary me-2"
        @click="aplicarFiltros"
        :disabled="loading"
      >
        Aplicar filtros
      </button>
      <button
        class="btn btn-sm btn-outline-secondary"
        @click="resetFiltros"
        :disabled="loading"
      >
        Limpiar filtros
      </button>
    </div>

    <!-- Tabla -->
    <div class="table-responsive w-100">
      <table class="table table-striped table-hover table-sm" id="tablaComparacion">
        <thead>
          <tr>
            <th>Año</th>
            <th class="text-end">Suma de Total Pagado</th>
            <th class="text-end">Suma de Total Recibos Posteados</th>
            <th class="text-end">Diferencia</th>
          </tr>
        </thead>

        <tbody v-if="ready && filas.length > 0">
          <tr v-for="fila in filas" :key="fila.anio">
            <td>{{ fila.anio }}</td>
            <td class="text-end">
              {{ formatearLempiras(fila.totalPagado) }}
            </td>
            <td class="text-end">
              {{ formatearLempiras(fila.totalRecibosPosteados) }}
            </td>
            <td class="text-end">
              {{ formatearLempiras(fila.diferencia) }}
            </td>
          </tr>
        </tbody>

        <tbody v-else-if="loading">
          <tr>
            <td colspan="4" class="text-center">
              <div class="spinner-border text-warning" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </td>
          </tr>
        </tbody>

        <tbody v-else>
          <tr>
            <td colspan="4" class="text-center">
              No hay datos para los filtros seleccionados.
            </td>
          </tr>
        </tbody>

        <tfoot v-if="ready && filas.length > 0">
          <tr class="table-dark">
            <td>Total general</td>
            <td class="text-end">
              {{ formatearLempiras(totalGeneral.totalPagado) }}
            </td>
            <td class="text-end">
              {{ formatearLempiras(totalGeneral.totalRecibosPosteados) }}
            </td>
            <td class="text-end">
              {{ formatearLempiras(totalGeneral.diferencia) }}  
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</template>

<script>
import Security from "../security";

export default {
  name: "ComparacionTotalesTable",

  // Props para poder controlar filtros desde el componente padre
  props: {
    anioInicio: {
      type: Number,
      default: 2020,
    },
    anioFin: {
      type: Number,
      default: new Date().getFullYear(),
    },
    tipoCartera: {
      type: String,
      default: "",
    },
    estado: {
      type: String,
      default: "",
    },
    producto: {
      type: String,
      default: "",
    },
    userAdmin: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      filas: [], // viene del backend
      ready: false,
      loading: false,

      filtrosLocal: {
        anioInicio: null,
        anioFin: null,
        tipoCartera: "",
        estado: "",
        producto: "",
        userAdmin: 0,
      },

      // Opciones de ejemplo (luego puedes cargarlas por props o API)
      opcionesTipoCartera: [
        {id:1, nombre: "AHDECO"},
        {id:2, nombre: "CREDITO SOLIDARIO"},
      ],
      opcionesEstado: ["ACTIVO", "LEGAL", "CANCELADO"],
      opcionesProducto: ["MICROCRÉDITO", "CONSUMO", "CREDI IMPULSA"],
      opcionesAsesores: [
        { id: 1, nombre: "Asesor 1" },
        { id: 2, nombre: "Asesor 2" },
        { id: 3, nombre: "Asesor 3" },
      ],
    };
  },

  computed: {
    totalGeneral() {
      const tot = {
        totalPagado: 0,
        totalRecibosPosteados: 0,
        diferencia: 0,
      };

      this.filas.forEach((f) => {
        tot.totalPagado += f.totalPagado || 0;
        tot.totalRecibosPosteados += f.totalRecibosPosteados || 0;
      });

      tot.diferencia = tot.totalPagado - tot.totalRecibosPosteados;
      return tot;
    },
  },

  methods: {
    formatearLempiras(valor) {
      if (valor == null || isNaN(valor)) return "L-";
      return (
        "L" +
        Number(valor).toLocaleString("es-HN", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      );
    },

    resetFiltros() {
      this.filtrosLocal.anioInicio = this.anioInicio;
      this.filtrosLocal.anioFin = this.anioFin;
      this.filtrosLocal.tipoCartera = this.tipoCartera || "";
      this.filtrosLocal.estado = this.estado || "";
      this.filtrosLocal.producto = this.producto || "";
      this.filtrosLocal.userAdmin = this.userAdmin || 0;
    },

    aplicarFiltros() {
      // Cuando se pulse "Aplicar filtros", recargamos desde el backend
      this.cargarDatosDesdeAPI();
    },

    async cargarDatosDesdeAPI() {
      this.loading = true;
      this.ready = false;

      const payload = {
        anioInicio: this.filtrosLocal.anioInicio,
        anioFin: 2026,
        tipoCartera: this.filtrosLocal.tipoCartera.toString(),
        estado: this.filtrosLocal.estado,
        producto: this.filtrosLocal.producto,
        userAdmin: this.filtrosLocal.userAdmin,
      };

      try {
        const response = await fetch(
          process.env.VUE_APP_API_URL + "/admin/credito/comparacion-totales",
          Security.requestOptions(payload, "POST")
        );

        const data = await response.json();

        if (data.error) {
          this.$emit("error", data.message || "Error en la consulta");
          console.error(data.message);
          this.filas = [];
        } else {

            console.log("Data de Comparacion",data);
          // Asumiendo que el handler devuelve: data: { comparacion: [...] }
          this.filas = data.data?.comparacion || [];

          // Si quisieras mapear los nombres, por si el backend manda otro formato:
          this.filas = this.filas.map((f) => ({
            anio: f.anio,
            totalPagado: f.totalPagado,
            totalRecibosPosteados: f.totalRecibosPosteados,
            diferencia:
              f.diferencia != null
                ? f.diferencia
                : (f.totalPagado || 0) - (f.totalRecibosPosteados || 0),
          }));

          this.$emit("loaded", this.filas);
        }

        this.ready = true;
      } catch (error) {
        this.$emit("error", error);
        console.error(error);
        this.filas = [];
        this.ready = true;
      } finally {
        this.loading = false;
      }
    },
  },

  mounted() {
    // Inicializar filtros con los props
    this.resetFiltros();
    // Cargar datos iniciales
    this.cargarDatosDesdeAPI();
  },

  watch: {
    // Si cambian los props desde el padre, actualizamos filtros
    anioInicio(newVal) {
      this.filtrosLocal.anioInicio = newVal;
    },
    anioFin(newVal) {
      this.filtrosLocal.anioFin = newVal;
    },
    tipoCartera(newVal) {
      this.filtrosLocal.tipoCartera = newVal || "";
    },
    estado(newVal) {
      this.filtrosLocal.estado = newVal || "";
    },
    producto(newVal) {
      this.filtrosLocal.producto = newVal || "";
    },
    userAdmin(newVal) {
      this.filtrosLocal.userAdmin = newVal || 0;
    },
  },
};
</script>

<style scoped>
.table-sm th,
.table-sm td {
  padding: 0.35rem 0.5rem;
}
</style>
